import { Box, Typography, Chip } from '@mui/material'
import PetAvatar from './PetAvatar'

const STATUS_CONFIG = {
	booked: { bg: '#B2F5EA', color: '#2C7A7B', label: 'Upcoming' },
	bookPending: { bg: '#FEFCBF', color: '#975A16', label: 'Pending' },
	completed: { bg: '#C6F6D5', color: '#276749', label: 'Completed' },
	noShow: { bg: '#FED7D7', color: '#9B2C2C', label: 'No Show' },
	cancelled: { bg: '#FED7D7', color: '#9B2C2C', label: 'Cancelled' }
}

function formatTime(ts) {
	if (!ts) return '—'
	const d = new Date(ts)
	const h = d.getHours()
	const m = d.getMinutes()
	const ampm = h >= 12 ? 'PM' : 'AM'
	const h12 = h % 12 || 12
	return `${h12}:${String(m).padStart(2, '0')} ${ampm}`
}

export default function MobileDashboardAppointmentCard({ appointment, onClick }) {
	const st = STATUS_CONFIG[appointment.status] || STATUS_CONFIG.booked

	return (
		<Box
			onClick={onClick}
			sx={{
				bgcolor: '#FFFFFF',
				borderRadius: '10px',
				border: '1px solid rgba(0,0,0,0.08)',
				p: '14px',
				cursor: 'pointer',
				display: 'flex',
				flexDirection: 'column',
				gap: '10px',
				boxShadow: '0px 1px 4px rgba(12,12,13,0.05)',
				'&:active': { bgcolor: '#F7FAFC' }
			}}
		>
			<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
				<Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px', color: '#2D3748' }}>
					{formatTime(appointment.startTs)}
				</Typography>
				<Chip
					label={st.label}
					size="small"
					sx={{ bgcolor: st.bg, color: st.color, fontSize: '12px', fontWeight: 400, height: '24px', borderRadius: '9999px' }}
				/>
			</Box>

			<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
				<PetAvatar petId={appointment.petId} size={36} />
				<Box sx={{ flex: 1, minWidth: 0 }}>
					<Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px', color: '#2D3748', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
						{appointment.petName}
					</Typography>
					<Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: '12px', color: '#A0AEC0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
						{appointment.clientName}
					</Typography>
				</Box>
			</Box>

			<Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: '13px', color: '#718096' }}>
				{appointment.serviceName}
			</Typography>
		</Box>
	)
}
